"use client";

import { useContext } from "react";

import { ThemeContext, type ThemeContextState } from "../contexts/ThemeContext";

/**
 * Hook to access the current theme context
 * @returns The current theme context state
 * @throws Error if used outside of ThemeProvider
 */
export function useTheme(): ThemeContextState {
  const context = useContext(ThemeContext);

  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }

  return context;
}
